import { render } from "./SignUp.vue?vue&type=template&id=57b2897d&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"

import "./SignUp.vue?vue&type=style&index=0&id=57b2897d&scoped=true&lang=css"

import exportComponent from "C:\\workspaces\\guest-pass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b2897d"]])

export default __exports__